import { FC } from 'react';

export interface SvgScrollDownProps {
  size?: number;
}

export const SvgScrollDown: FC<SvgScrollDownProps> = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 5v14" />
    <path d="m5 12 7 7 7-7" />
  </svg>
);
